/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* Klervel — photo de la couleur choisie (24/10/2026) */
document.addEventListener('change', function (e) {
  var champ = e.target;
  if (!champ || champ.name !== 'id' || !window.productVariants) return;
  var v = window.productVariants.find(function (x) { return String(x.id) === String(champ.value); });
  if (!v || !v.featured_media) return;
  var vignette = document.querySelectorAll('.product-gallery .thumbs-splide .splide__slide')[v.featured_media.position - 1];
  if (vignette) vignette.click();
  else window.dispatchEvent(new CustomEvent('variantChange.shopiweb.product', {detail: v}));
}, true);
/* fin : photo de la couleur choisie */

/* Klervel — 1 portefeuille coché d'office (25/10/2026) */
(function () {
  if (!document.querySelector('moonbundle-component')) return;
  var touche = false;
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('moonbundle-component')) touche = true; }, true);
  var essais = 0;
  var t = setInterval(function () {
    essais++;
    var options = document.querySelectorAll('moonbundle-component .moonbundle-option');
    if (options.length > 1 && !touche) {
      if (!options[0].classList.contains('moonbundle-option-active')) options[0].click();
      else if (essais > 6) clearInterval(t);
    }
    if (touche || essais > 40) clearInterval(t);
  }, 250);
})();
/* fin : 1 portefeuille coché d'office */
